/**
 * Does the model need to hear what its tools did before the answer is complete?
 *
 * Every extra round is another full trip to the model — a second or more of
 * somebody sitting in front of a spinner — so it is only made when it changes
 * what they get:
 *
 *   - A tool that hands the model information it has to put into words
 *     (`lookup`). `show` is not one: it changes the screen, and the model says
 *     what it has to say in the same turn — only when it said nothing does the
 *     rule below send it back for a sentence.
 *   - A tool that did not work — no id, a screen their mode hides — so the model
 *     can recover instead of leaving them with nothing.
 *   - Nothing to show for the round yet: no words and no walkthrough.
 *
 * Otherwise the answer is already on the screen. The commonest case is a how-to:
 * `guide` starts the walkthrough, whose steps are spoken as they light up, and a
 * second round only ever produced a sentence the tool result told it not to add.
 */
const TELLS_THE_MODEL = new Set(['lookup']);

export interface ToolOutcome {
  name: string;
  /** The tool changed what the person sees — it worked. */
  worked: boolean;
}

export function needsFollowUp(outcomes: ToolOutcome[], said: boolean, showing: boolean): boolean {
  if (outcomes.some((o) => TELLS_THE_MODEL.has(o.name))) return true;
  if (outcomes.some((o) => !o.worked)) return true;
  return !(said || showing);
}
